import React from 'react'
import { Link } from 'react-router-dom'
import ReadMore from '../Common/ReadMore'
import Slider from "react-slick";
import { getImages } from '../Common/const';

const SrpSmBox = ({ item, index, priceFormatter }) => {

    const optionssl = {
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        dots: true,
        infinite: item.images.length > 1,
        pauseOnHover: false
    };

    //infinite: item.images.length >= 3
    return (
        <>
            <div className='col-lg-4 col-md-6 col-12' key={index}>
                <div className='pro-box'>
                    <div className='pro-content'>
                        <div className='before-hover'>
                            <div className='pro-top'>
                                {item.images.length > 0 ?
                                    <Link to={"/vdp?vin=" + item.vin}>
                                        <img src={item.images[0]} alt='srp' />
                                    </Link>
                                :
                                    <Link to={"/vdp?vin=" + item.vin}>
                                        <img src={getImages('vdp_top_coming_soon.webp')} alt='' />
                                    </Link>
                                }
                            </div>
                            <div className='pro-bottom'>
                                <div className="d-flex align-items-center justify-content-between mb-2">
                                    <div className="fv-title mb-0">{item.vehicle_name}</div>
                                    <div>
                                        <button className='info-icon'>
                                            <img src={getImages('info-icon.png')} alt='icon' />
                                        </button>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-between mt-1">
                                    <div className="fv-price">{priceFormatter(item.price, true)}</div>
                                    <div className="fv-mileage">{item.mileage.toLocaleString()}mi</div>
                                </div>
                                <div className='mt-2'>
                                    <a
                                        href={"/vdp?vin=" + item.vin}
                                        type='button'
                                        className='vehicle-dtl-btn xs-title text-uppercase text-center'>
                                        Vehicle Details
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className='after-hover'>
                            <div className='pro-top'>
                                {item.images.length > 0 ?
                                    <Slider
                                        className="featured-slider"
                                        {...optionssl}
                                    >
                                        <div className="slide-item">
                                            <Link to={"/vdp?vin=" + item.vin}>
                                                <img src={item.images[0]} />
                                            </Link>
                                        </div>
                                        {1 in item.images && <div className="slide-item">
                                            <Link to={"/vdp?vin=" + item.vin}>
                                                <img src={item.images[1]} />
                                            </Link>
                                        </div>}
                                        {2 in item.images && <div className="slide-item">
                                            <Link to={"/vdp?vin=" + item.vin}>
                                                <img src={item.images[2]} />
                                            </Link>
                                        </div>}
                                    </Slider>
                                    :
                                    <div style={{ cursor: 'pointer' }} key={"vdp" + index}>
                                        <Link to={"/vdp?vin=" + item.vin}>
                                            <img src={getImages('vdp_top_coming_soon.webp')} alt='' />
                                        </Link>
                                    </div>
                                }
                            </div>
                            <div className='pro-bottom'>
                                <div className="d-flex align-items-center justify-content-between prob-info flex-wrap">
                                    <div className='w-50 pe-4'>
                                        <div className='d-flex align-items-center w-100 mb-xl-2'>
                                            <div className='xs-title fw-400 w-30'>Stock #</div>
                                            <div className='sm-title text-end w-70'>{item.stockno}</div>
                                        </div>
                                        <div className='d-flex align-items-center w-100'>
                                            <div className='xs-title fw-400 w-30'>VIN</div>
                                            <div className='sm-title text-end w-70'>{item.vin}</div>
                                        </div>
                                    </div>
                                    <div className='w-50 ps-3'>
                                        {item.interior_color &&
                                            <div className='d-flex align-items-center w-100 mb-xl-2'>
                                                <div className='xs-title fw-400 w-40'>Interior Color</div>
                                                <div className='sm-title text-end w-60'>{item.interior_color}</div>
                                            </div>
                                        }
                                        {item.exterior_color &&
                                            <div className='d-flex align-items-center w-100'>
                                                <div className='xs-title fw-400 w-40'>Exterior Color</div>
                                                <div className='sm-title text-end w-60'>{item.exterior_color}</div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <hr className='custom-hr' />
                                {item.description &&
                                    <ReadMore
                                        key={index}
                                        text={item.description}
                                        maxChars={230}
                                        sectionId="aboutVdp"
                                        readMoreUrl={"/vdp?vin=" + item.vin}
                                    />
                                }
                                {/* <div className="d-flex align-items-center justify-content-between mt-2 pt-2 srp-actions-flex">
                                    <div>
                                        <button type='button' className='view-sticker-btn text-green'><span className='doc_icon'></span> View Window Sticker</button>
                                    </div>
                                    <div>
                                        <Link to={"/vdp?vin=" + item.vin} className="vehicle-dtl-btn flip-dtl-btn text-uppercase" >Vehicle Details</Link>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SrpSmBox